import { send } from 'server';

export const getRgConfiguration = () => send({
    ID: 32942,
    responses: [32943, 32944],
    description: 'Get Responsible Gaming Configuration',
    type: [0, 1, 2, 3, 4, 5],
    casino: window.Playtech.Variables.casinoName,
    currencyCode: window.Playtech.Variables.defaultCurrency
});

export const fetchLimits = () => send({
    ID: 35622,
    responses: [35623, 35624],
    description: 'Get Player Login Limits'
});
